import React, { memo } from 'react';
import { Icon } from 'Components/Icons';

import { Label } from 'Components/Label';
import { TextBox } from 'Components/TextBox';
import { PurpleButton } from 'Components/Button';
import { ValidateBackGround } from 'Components/Validation';
import { CheckBox } from 'Components/CheckBox';
import DatePicker from 'react-datepicker';

import { Modal } from 'Components/Modal';

import formClasses from 'Themes/form/form.module.css';
import classes from './editLogModal.module.css';

interface Props {
  // modal variables
  isOpen: boolean;
  formErrors: any;
  isProcessing: boolean;

  // moisture log variables
  latestAverage?: string;
  removed?: boolean;
  recordTime?: any;

  // modal functions
  onSaveButtonClick: (e: any) => void;
  closeModal: (e: any) => void;

  // moisture log functions
  onChangeLatestAverage: (e: any) => void;
  onRemovedCheckboxClick: (e: any) => void;
  onChangeRecordTime: (e: any) => void;
}

function EditMoistureLogReadingModal({
  isOpen,
  formErrors,
  isProcessing,
  latestAverage,
  removed,
  recordTime,
  onSaveButtonClick,
  closeModal,
  onChangeLatestAverage,
  onRemovedCheckboxClick,
  onChangeRecordTime,
}: Props) {
  return (
    <Modal title="Edit Damage Material Log Reading" isOpen={isOpen} classes={{ modalDialog: classes.modalOverride }}>
      <h5 className={classes.heading}>
        Edit Damage Material Log Reading
        <Icon type="close" className={classes.closeModal} onClick={closeModal} />
      </h5>
      <form
        className={`requires-validation g-3 ${formClasses.formBase} ${classes.container}`}
        noValidate
        action="#"
        onSubmit={() => {}}
      >
        <div className={classes.formWrapper}>
          {!removed && (
            <div>
              <ValidateBackGround isValid={!formErrors?.reading?.length}>
                <Label ariaLabel="New Average" className={formClasses.label} htmlFor="latestAverage">
                  Latest Average
                </Label>
                <TextBox
                  value={latestAverage}
                  name="latest average"
                  type="text"
                  className={`mb-0 pb-0 ${formClasses.validateField} ${
                    formErrors?.reading?.length ? formClasses.invalidField : formClasses.validField
                  } ${formErrors?.reading?.length ? 'is-invalid' : ''}`}
                  placeholder=""
                  ariaLabel="Please enter the latest average"
                  onChange={onChangeLatestAverage}
                  autoComplete="off"
                />
                <div className={`${formClasses.invalidFieldFeedback} invalid-feedback`}>{formErrors.reading}</div>
              </ValidateBackGround>
            </div>
          )}
          <div>
            <CheckBox checked={removed} className={classes.checkbox} onChange={onRemovedCheckboxClick} /> Material
            Removed
          </div>
          <div className="rocketdry-datetime-picker">
            <ValidateBackGround isValid>
              <Label ariaLabel="Recorded On" className={formClasses.label} htmlFor="recordedOn">
                Recorded On
              </Label>
              <br />
              <DatePicker
                selected={recordTime}
                onChange={onChangeRecordTime}
                showTimeSelect
                required
                dateFormat="MM/dd/yyyy h:mm aa"
                maxDate={new Date()}
                popperProps={{ strategy: 'fixed' }}
                className={`form-control ${formClasses.validateField} ${formClasses.validField}`}
              />
            </ValidateBackGround>
          </div>
          <div className={`modal-footer ${classes.modalFooter}`}>
            <PurpleButton onClick={closeModal} className={classes.cancelButton}>
              Cancel
            </PurpleButton>
            <PurpleButton
              onClick={onSaveButtonClick}
              className={classes.saveButton}
              disabled={isProcessing || (!latestAverage && !removed) || !recordTime}
            >
              Save
            </PurpleButton>
          </div>
        </div>
      </form>
    </Modal>
  );
}

EditMoistureLogReadingModal.defaultProps = {
  latestAverage: undefined,
  removed: undefined,
  recordTime: undefined,
};

const EditMoistureLogReadingModalMemo = memo(EditMoistureLogReadingModal);

export { EditMoistureLogReadingModalMemo as EditMoistureLogReadingModal };
